import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useSupplierService } from "serviceHooks";
import { useNavigate } from "react-router-dom";
import { UrlHelper } from "utils/helpers";
import { ServiceConstants } from "utils/constants";
import { SupplierFormTypes } from "models/formTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

//#endregion

const Top3ComparableChart: React.FC = () => {
  const supplierService = useSupplierService();
  const seriesNamesRef = React.useRef<string[]>([]);
  const labelFormatter = (label?: string) => {
    return label ? label.substring(0, 3) : "";
  };
  const navigate = useNavigate();

  const legendFormatter = (index: number, name?: string): string => {
    return name ?? "";
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Line}
      chartAPIKey={GraphConstants.ChartKeys.SuppliersTop3Comparable}
      labelFormatter={labelFormatter}
      legendFormatter={legendFormatter}
      filterToAPIHandler={supplierService.reportToAPIFilter}
      usePageFilter={false}
      useClickableChart
      onChartSuccessHandler={(data) => {
        try {
          seriesNamesRef.current = data?.data?.map((s) => s.name ?? "") ?? [];
        } catch {
          seriesNamesRef.current = [];
        }
      }}
      onPeriodClick={(args: any) => {
        const name = seriesNamesRef.current?.[args?.datasetIndex ?? -1];
        if (!name) return;
        const pagination = { ...ServiceConstants.DefaultFilter } as any;
        const filter: SupplierFormTypes.Filter = { search: name } as SupplierFormTypes.Filter;
        supplierService.getSuppliers(pagination, filter).then((res) => {
          const items = res.data?.items ?? [];
          const exact = items.find((it: any) => (it.name ?? "").toLowerCase() === name.toLowerCase());
          const target = exact ?? items[0];
          if (target?.id) navigate(UrlHelper.formatPath(`/Supplier/${target.id}`));
        });
      }}
    />
  );
};

export default Top3ComparableChart;
